import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08, duration: 1.2, smoothWheel: true }}>
      <div className="App noise-overlay bg-manor-bg text-manor-text min-h-screen">
        <Landing />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#16211C",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "#FFFBEF",
              fontFamily: "Montserrat, sans-serif",
            },
          }}
        />
      </div>
    </ReactLenis>
  );
}

export default App;
